export class UpdateBillingCharacteristicsRequestModel {

    constructor(private productOffering: any, private offerName: string, private comment: string) {
    }

    public static create() {
        return new UpdateBillingCharacteristicsRequestModel(null, '', 'Billing characteristics updated.');
    }
}
